<template>
    <b-container class="notification-list">
        <b-row v-for="notification in notifications" class="notification-cell">
            <b-col cols="12" class="notification-cell-content text-left">{{notification.content}}</b-col>
            <b-col cols="12" class="notification-cell-timestamp text-right">{{notificationCreateAtLabel(notification)}}</b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'

    export default {
        name: 'NotificationList',
        mounted() {
            this.getNotifications();
        },
        computed: {
            notifications() {
                return this.$store.state.notifications;
            },
            unreadNotificationCount() {
                let count = 0;

                this.$store.state.notifications.forEach(function (n) {
                    if (!n.read_at) {
                        count += 1
                    }
                });

                return count;
            },
        },
        methods: {
            getNotifications() {
                this.$storeDispatch('getNotifications');
            },
            readNotifications() {
                let unread_notification_ids = [];

                this.$store.state.notifications.forEach(function (n) {
                    if (!n.read_at) {
                        unread_notification_ids.push(n.id);
                    }
                });

                if (unread_notification_ids.length === 0) {
                    return;
                }

                this.$callAPI('notifications/read/', {
                    notification_ids: unread_notification_ids,
                }, function (response) {
                    if (response.body.success) {
                        this.$storeDispatch('getNotifications');
                    }
                }, function (response) {
                    console.log('READ NOTIFICATIONS FAILED:');
                    console.log(response);
                });
            },
            notificationCreateAtLabel(notification) {
                return DateTime.fromISO(notification.create_at).toFormat('yyyy-MM-dd HH:mm');
            },
        }
    }
</script>

<style lang="less">
    .notification-list {
        .notification-cell {

            border-bottom: 1px solid rgba(0, 0, 0, 0.3);

            .notification-cell-content {
                padding: 1rem;
            }

            .notification-cell-timestamp {
                font-size: 0.8rem;
                color: rgba(0, 0, 0, 0.8);
            }
        }
    }
</style>